import React, { useEffect } from 'react'
import { useScrollYPosition } from 'react-use-scroll-position'
import 'normalize.css'
import { Helmet } from 'react-helmet'

import '../style/index.scss'
import SEO from './SEO'

const omaComponentUrl = (component) =>
  `https://unpkg.com/@oma-wc/${component}/dist/index.cjs.js`

export default ({
  children,
  pageTitle,
  siteImageRelativePath,
  fontAwesome = false,
  omaComponents = [],
}) => {
  const scrollY = useScrollYPosition()
  const scrolled = scrollY > 20
  const omaComponentsToLoad = ['site@0.7.0', ...omaComponents]

  useEffect(() => {
    document.documentElement.classList.toggle('scrolled', scrolled)
  }, [scrolled])

  useEffect(() => {
    omaComponentsToLoad.forEach((component, index) => {
      const script = document.createElement('script')
      const existingScript = document.getElementById(component)

      if (existingScript) return

      script.src = omaComponentUrl(component)
      script.id = component
      script.async = true
      script.type = 'module'
      script.key = index
      document.body.appendChild(script)
    })
  }, [])

  useEffect(() => {
    if (!fontAwesome) {
      return
    }

    const fontAwesomeScript = document.createElement('script')
    fontAwesomeScript.async = true
    fontAwesomeScript.src = 'https://kit.fontawesome.com/15a4391064.js'
    fontAwesomeScript.crossorigin = 'anonymous'
    document.body.appendChild(fontAwesomeScript)
  }, [fontAwesome])

  return (
    <>
      <SEO
        pageTitle={pageTitle}
        siteImageRelativePath={siteImageRelativePath}
      />
      <oma-site>{children}</oma-site>
    </>
  )
}
